import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-brand',
  templateUrl: './about-brand.component.html',
  styleUrls: ['./about-brand.component.css']
})
export class AboutBrandComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/about-brand/about-brand.component.ts